import { AjaxResponse } from 'rxjs/ajax';
import { InvalidResponseError } from '../errors/invalid-response.error';

export const isHtmlResponse = (response: AjaxResponse<unknown>): boolean => {
  const contentType = response.xhr?.getResponseHeader('content-type') || '';
  return contentType.includes('text/html');
};

export const validateJsonResponse = <T>(response: AjaxResponse<T>): AjaxResponse<T> => {
  if (isHtmlResponse(response)) {
    const responseText = typeof response.response === 'string' ? response.response : 'HTML response received';

    throw new InvalidResponseError(
      'Server returned HTML instead of JSON',
      response.status,
      response.xhr?.getResponseHeader('content-type') || null,
      responseText,
    );
  }
  return response;
};
